import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Spin,
  Form,
  Button,
  Divider,
  Tooltip,
  Table,
  Col,
} from "antd";
import {
  SearchOutlined,
  RollbackOutlined,
  FileAddOutlined,
  FolderOpenOutlined,
  LeftOutlined,
  EditOutlined,
  DeleteOutlined,
  DollarOutlined,
  FlagOutlined,
  LikeOutlined,
  DislikeOutlined,
  SaveOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import TopContent from "../../../../../../components/layouts/TopContent";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";

import "../../../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import RecordStatus from "../../../../../../components/RecordStatus";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import CustomButton from "../../../../../../components/custom/CustomButton";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const { Text, Title } = Typography;

const DetailCharge = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [tableCount, setTableCount] = useState("10");
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [chargeDetail, setChargeDetail] = useState({});
  const [inputField, setInputField] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log(state);
    getDetailById();
  }, []);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: " Name",
      dataIndex: "officeName",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Transaction Date",
      dataIndex: "transactionDate",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Reversed",
      dataIndex: "reversed",
      render: (text) => (
        <Text strong style={{ color: text ? "green" : "red" }}>
          {text ? "True" : "False"}
        </Text>
      ),
      // sorter: (a, b) => a.paid.localeCompare(b.paid),
    },
    {
      title: "Actions",
      dataIndex: "reversed",
      render: (text, record) =>
        !text && (
          <>
            <Tooltip title={"Reverse Transaction"}>
              <Button
                type="primary"
                icon={<RollbackOutlined />}
                onClick={() => handleTransactionReverse(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          </>
        ),
    },
  ];

  function handleTransactionReverse(record) {
    let action = "Reverse  ";
    let label = record.type;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${apiConfig.Clients}/${state.id}/transactions/${record.id}?command=undo`;
        const body = {
          method: "POST",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.reversedChargeMsg);
              getDetailById();
              // navigate("/detail-charge", {
              //   state: {
              //     id: chargeDetail.id,
              //     clientDetails: chargeDetail.clientId,
              //   },
              // });
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              // navigate(0);
              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No button
      }
    );
  }

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${state.id}/charges/${state.recordDetails.id}?associations=all`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempTransactionData = [];
        console.log(objDetail);
        setChargeDetail(objDetail);
        setIsLoading(false);

        setInputField([
          {
            name: labelConfig.name,
            value: objDetail.name,
          },
          {
            name: labelConfig.due,
            value: objDetail.amount,
          },
          {
            name: labelConfig.outstanding,
            value: objDetail.amountOutstanding,
          },

          {
            name: labelConfig.paid,
            value: objDetail.amountPaid,
          },

          {
            name: labelConfig.waived,
            value: objDetail.amountWaived,
          },
          {
            name: labelConfig.chargeCalculationType,
            value: objDetail.chargeCalculationType.value,
          },
          {
            name: labelConfig.chargeTimeType,
            value: objDetail.chargeTimeType.value,
          },
          {
            name: labelConfig.currency,
            value: objDetail.currency.name,
          },
          {
            name: labelConfig.dueAsOf,
            value: BOM.DateTime(objDetail.dueDate, "only-date"),
          },
        ]);
        if (objDetail.clientTransactionDatas) {
          objDetail?.clientTransactionDatas.forEach((element) => {
            tempTransactionData.push({
              key: element?.id,
              id: element?.id,
              officeName: element?.officeName ? element?.officeName : "-",
              transactionDate: element?.date
                ? BOM.DateTime(element?.date, "only-date")
                : "-",
              type: element?.type ? element?.type.value : "-",
              amount: element?.amount,
              reversed: element.reversed,
            });
          });
        }
        setTransactionDetails(tempTransactionData);
        // ENABLE DELETE BUTTON
        dispatch({
          type: cnt.RIGHT_DELETE_BTN,
        });
        setIsLoading(false);
      }
    });
  };

  const handleOnDelete = () => {
    let action = "Delete  ";
    let label = chargeDetail.name;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${apiConfig.Clients}/${state.id}/charges/${chargeDetail.id}?associations=all`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteChargeMsg);
              navigate("/detail-customer", {
                state: { ...state },
              });
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              // navigate(0);
              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No button
      }
    );
  };

  function handlePayCharge() {
    navigate("/pay-charge", {
      state: { ...state },
    });
  }

  function handleWaiveCharge() {
    let action = "Waive  ";
    let label = chargeDetail.name;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${apiConfig.Clients}/${state.id}/charges/${chargeDetail.id}?command=waive`;
        const body = {
          method: "POST",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.waivedChargeMsg);
              getDetailById();

              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              // navigate(0);
              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No button
      }
    );
  }

  function backOnClick() {
    navigate("/detail-customer", {
      state: {
        ...state,
      },
    });
  }
  // function backOnClick() {
  //   navigate("/detail-customer", {
  //     state: {
  //       id: state.clientDetails.id,
  //       branchId: state.clientDetails.branchId,
  //     },
  //   });
  // }

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailCharge}
        pageItems={staticConfig.detailChargeBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          style={{
            marginBottom: 25,
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={backOnClick}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
              {!chargeDetail.isWaived && (
                <>
                  <Button
                    type="primary"
                    icon={<DollarOutlined />}
                    onClick={() => handlePayCharge()}
                    shape="round"
                    size="small"
                    style={{
                      // width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    className="of-primaryBtnColor"
                  >
                    Pay Charge
                  </Button>
                  <Button
                    type="primary"
                    icon={<FlagOutlined />}
                    onClick={() => handleWaiveCharge()}
                    shape="round"
                    size="small"
                    style={{
                      marginLeft: "1%",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    className="of-primaryBtnColor"
                  >
                    Waive Charge
                  </Button>
                </>
              )}
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              {inputField.map((item, index) => (
                <Col span={8} style={{ padding: "0px 8px" }} key={index}>
                  <Form.Item label={<Text strong>{item.name}</Text>}>
                    <Input disabled value={item.value} />
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Form>

          <Row>
            <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.transactions}
            </Title>
          </Row>
          <Divider style={{ marginTop: 10, marginBottom: 30 }} />
          <Table columns={columns} dataSource={transactionDetails} bordered />
        </Card>

        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailCharge);
